// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js'

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Service
import SocialClubService from "@/app/services/main/social-club/social-club-service";

export default {
	name: 'SocialClubsContainer',
	mixins: [
		tableMixins,
		toastMessageMixins
	],
	data() {
		return {
			isAPILoading: false,
			statusList: [{name:'ACTIVE', value: true}, {name:'INACTIVE', value: false}],
			breedList: [],
			isBreedsListLoading: false,
			// table
			theads: [
				{name: 'Group Club', searchLabel: 'f_name', sortLabel: 'name', isDesc: false, hasSearch: true, style: 'min-width: 100px'},
				{name: 'Number of Members', searchLabel: null, sortLabel: 'memberCount', isDesc: false, hasSearch: false, style: null},
				{name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: 'min-width: 100px;'}
			],
			// sorting
			desc: false
		}
	},
	created() {
		this.getTableContent();
	},
	methods: {
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page;
			this.getClubs({ page, limit, sortBy, desc });
		},
		getClubs(queryParams) {
			this.isAPILoading = true;

			// search dropdown filters
			if (this.columnsFilter) {
				const {
					f_name
				} = this.columnsFilter;

				if (f_name) {
					queryParams['f_name'] = f_name;
				}
			}

			SocialClubService.getGroups(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
					} else {
						this.showAPIErrorToast('Unable to fetch social club list.', res);
					}

					this.isAPILoading = false;
				});
		},
		setActiveGroup(group) {
			this.$store.commit('setActiveGroup', group);
			this.$router.push('/social/members');
		}
	}
}